import "./LocalSEO.module.css";
import Header from "@/reusable_sections/Header";
import Localdomination from "./sections/Localdomination";
import LocalBenefits from "./sections/LocalBenefits";
import Localseo from "./sections/Localseo";
import Localseomethodology from "./sections/Localseomethodology";
import LocalSeoSupport from "./sections/LocalSeoSupport";
import FaqAccordion from "./sections/FaqAccordion";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function LocalSEOPage() {
  return <div>
      <Header />
      <Localdomination />
      <LocalBenefits />
      <Localseo />
      <Localseomethodology />
      <LocalSeoSupport />
      <FaqAccordion />
      <Consultation />
      <Footer />
    </div>;
}